import React from "react";
import { humanEUR } from "../../cost-control/forecast/format";

// One sentence about idle capacity, in one place.
//
// "Actual cost" means two different things on this page, deliberately: the
// Actual KPI INCLUDES idle capacity so it reconciles to the invoice, while
// every breakdown figure — the chart's actual metric, the economics chart's
// actual line, the contributors rows — EXCLUDES it, because idle capacity is
// the subscription fee on days with no usage and so belongs to no model, call
// type or owner. That split is correct. What was wrong was saying it in only
// one of the three places, leaving the other two looking like they disagreed
// with the KPI for no stated reason.
//
// Renders nothing when there is no idle capacity: there is then no
// discrepancy to explain, and a permanent caveat teaches the reader to skip
// caveats.
export default function IdleCapacityNote({ idleCapacity, className = "", children }) {
  if (!(idleCapacity > 0)) return null;
  return (
    <div className={`text-[12px] text-text-3 ${className}`}>
      Excludes {humanEUR(idleCapacity)} of idle capacity — subscription fee on days with no AI
      usage. It is part of the actual-cost KPI because it is on the invoice.
      {children ? " " : ""}
      {children}
    </div>
  );
}
